export default __webpack_public_path__ + "static/media/book-2.c8ad4d08.jpg";